import http from '@/utils/http'

export const loadTables = (nodeID, params = {}) => http.get(`/kuiper/${nodeID}/tables`, { params })

export const viewTable = (nodeID, id) => http.get(`/kuiper/${nodeID}/tables/${id}`)

export const createTable = (nodeID, kind = 'scan', body = {}) =>
  http.post(`/kuiper/${nodeID}/tables?kind=${kind}`, body)

export const deleteTable = (nodeID, id) => http.delete(`/kuiper/${nodeID}/tables/${id}`)

export const updateTable = (nodeID, params = {}, body = {}) =>
  http.put(`/kuiper/${nodeID}/tables/${params.id}?kind=${params.kind}`, body)

export default {}
